import { connect } from 'react-redux';
import { Container } from './Pagination';
import { change } from 'redux-form';
import * as selectDetail from '@app/src/views/CipReport/report/state/detail/selectors';
import * as selectFilterValues from '@app/src/views/CipReport/report/state/filterValues/selectors';
import { fetchDetail } from '@app/src/views/CipReport/report/state/detail/actions';
import { FilterModel } from '@app/src/views/CipReport/list/models/Filter';
import { fetchValidationReportToken } from '@app/src/views/CipReport/filter/state/validationReportToken/actions';
import { openModal } from '@app/src/commons/modal/state/modals/actions';
import { getSettings } from '@app/src/configuration/config.service';

const mapStateToProps = state => ({
  items: selectDetail.getItems(state),
  filter: selectFilterValues.getValues(state),
  totalPages: selectDetail.getTotalPages(state),
  page: selectDetail.getPage(state),
  totalRow: selectDetail.getTotalRow(state),
  isFetchingDetails: selectDetail.getIsFetching(state)
});
const mapDispatchToProps = dispatch => ({
  handleClickDownload: (filter: FilterModel) => {
    const reportToken = sessionStorage.getItem('reportToken');
    if (!reportToken) {
      dispatch(openModal('CLOSE_SESSION_MODAL'));
      return;
    }
    dispatch(fetchValidationReportToken(getSettings().API_VALIDATION_REPORT_TOKEN, filter, true));
  },
  getPage: (page: number, filter: FilterModel, url: string) => {
    dispatch(fetchDetail({ page, ...filter }, url, true));
    dispatch(change('filter', 'dateStart', filter.dateStart));
    dispatch(change('filter', 'dateEnd', filter.dateEnd));
    dispatch(change('filter', 'stateId', filter.stateId.toString()));
    dispatch(change('filter', 'userId', filter.userId.toString()));
    dispatch(change('filter', 'cip', filter.cip));
    dispatch(change('filter', 'documentNumber', filter.documentNumber));
  }
});

export const PaginationContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Container);
